import React from "react";
import icon_type_link from "../../Assets/svg/icon_type_link.svg";

export default function C_V_LINK({ value }) {
  if (!value) return null;

  const handleIconClick = (e) => {
    // Prevent the click from bubbling up to the grid (avoids edit mode)
    e.stopPropagation();

    let url = value.trim();
    // Check if the URL already starts with http:// or https://
    if (!/^https?:\/\//i.test(url)) {
      url = `https://${url}`;
    }

    // Open in a new tab securely
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        padding: "0 4px",
        boxSizing: "border-box",
      }}
    >
      <div
        className="badge_small background_grey_light"
        onClick={handleIconClick}
        title="Open link"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          margin: 0,
          padding: "2px 4px",
          cursor: "pointer",
        }}
      >
        <img
          src={icon_type_link}
          alt="Link"
          style={{ width: "12px", height: "12px", objectFit: "contain" }}
        />
      </div>

      <span
        className="badge_small background_grey_light"
        title={value}
        style={{
          display: "block",
          textAlign: "center",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: "100%",
          lineHeight: "1.5",
        }}
      >
        {value}
      </span>
    </div>
  );
}
